import React from 'react'
import PropTypes from 'prop-types'

export default class Checkbox extends React.Component {
  static propTypes = {
    value: PropTypes.bool,
    onChange: PropTypes.func
  }

  render() {
    return (
      <input
        type="checkbox"
        style={{ zoom: 2.0, marginLeft: 0 }}
        checked={this.props.value}
        onChange={() => this.props.onChange(!this.props.value)}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/fields/Checkbox/index.js